import React from 'react';
import './sideBar.css';
import navList from '../data/navItem.js';
import NavItem from './NavItem';
import { Link } from 'react-router-dom';



const SideBar=(props)=> {


    function CustomLink({ to, children, ...props}) {
        const path =window.location.pathname 
        return(
            <li className={path === to ? 'active' : ''}>
                <Link to={to} {...props}>
                    {children}
                </Link>

            </li>
        )
    }



  return (
    <aside className='sidebar' id='sidebar' >
     <ul className='sidebar-nav' id='sidebar-nav'>
        <li className='nav-item' onClick={props.homeclick}>
            <Link to="/home">
            <i className='bi bi-grid'></i>
            <span>Dashboard</span>
            </Link>
        </li>

        <li className='nav-item'>
            <Link to="#"
            className='nav-link collapsed'
            data-bs-target='#components-nav'
            data-bs-toggle='collapse'>
                <i className='bi bi-align-start'></i>
                <span>Agronomy</span>
                <i className='bi bi-chevron-down ms-auto'></i>
            </Link>
            <ul id='components-nav' className='nav-content collapse'
            data-bs-parent='#sidebar-nav'>
                <li onClick={props.agronomydashclick}>
                    <Link to="/AgronomyDash">
                        <i className='bi bi-circle'></i>
                <span>Agronomy Dashboard</span>
                </Link>
                </li>
                <li onClick={props.agronomyreportsclick}>
                    <Link to="/AgronomyReports">
                        <i className='bi bi-circle'></i>
                <span>Agronomy Reports</span>
                </Link>
                </li>
            </ul>
        </li>


        
        <li className='nav-item'>
            <a href="#"
            className='nav-link collapsed'
            data-bs-target='#receiving-nav'
            data-bs-toggle='collapse'>
                <i className='bi bi-truck'></i>
                <span>Loan Management</span>
                <i className='bi bi-chevron-down ms-auto'></i>

            </a>

            {/* Loans-NAV */}

            <ul id='receiving-nav' className='nav-content collapse'
            data-bs-parent='#sidebar-nav'>
                <li onClick={props.loansclick}>
                    <Link to="/Scale">
                        <i className='bi bi-circle'></i>
                <span>Loans Dashboard</span>
                </Link>
                </li>
                <li onClick={props.loansreportsclick}>
                    <Link to="/LoansReports">
                        <i className='bi bi-circle'></i>
                <span>Loans Reports</span>
                </Link>
                </li>
            </ul>
        </li>

        {/* Warehouse NAV */}

        <li className='nav-item'>
            <a href="#"
            className='nav-link collapsed'
            data-bs-target='#floor-nav'
            data-bs-toggle='collapse'>
                <i className='bi bi-shop-window'></i>
                <span>Warehouse</span>
                <i className='bi bi-chevron-down ms-auto'></i>

            </a>

            <ul id='floor-nav' className='nav-content collapse'
            data-bs-parent='#sidebar-nav'>
                <li onClick={props.warehouseclick}>
                    <Link to="/WarehouseDash">
                        <i className='bi bi-circle'></i>
                <span>Warehouse Dashboard</span>
                </Link>
                </li>
                <li onClick={props.warereportsclick}>
                    <Link to="/WarehouseReports">
                        <i className='bi bi-circle'></i>
                <span>Warehouse Reports</span>
                </Link>
                </li>
            </ul>
        </li>

        {/* SALES/CAPTURING */}

        <li className='nav-item'>
            <a href="#"
            className='nav-link collapsed'
            data-bs-target='#sales-nav'
            data-bs-toggle='collapse'>
                <i className='bi bi-ticket-perforated'></i>
                <span>Payroll</span>
                <i className='bi bi-chevron-down ms-auto'></i>

            </a>

            <ul id='sales-nav' className='nav-content collapse'
            data-bs-parent='#sidebar-nav'>
                <li onClick={props.payrolldashclick}>
                    <Link to="/PayrollDash">
                        <i className='bi bi-circle'></i>
                <span>Payroll Dashboard</span>
                </Link>
                </li>
                <li onClick={props.payrollreportsclick}>
                    <Link to="/PayrollReports">
                        <i className='bi bi-circle'></i>
                <span>Reports</span>
                </Link>
                </li>

            </ul>
        </li>
         
        <li className='nav-item' onClick={props.gmsclick}>
            <Link to="/Gms"
            className='nav-link collapsed'
            data-bs-target=''
            data-bs-toggle=''>
                <i className='bi bi-gear'></i>
                <span>Gms</span>
                <i className=''></i>

            </Link>
        </li>

        <li className='nav-item'>
            <a href="#"
            className='nav-link collapsed'
            data-bs-target=''
            data-bs-toggle=''>
                <i className='bi bi-gear'></i>
                <span>QuickAcc</span>
                <i className=''></i>

            </a>
        </li>

        <li className='nav-item'>
            <a href="#"
            className='nav-link collapsed'
            data-bs-target=''
            data-bs-toggle=''>
                <i className='bi bi-gear'></i>
                <span>LMS</span>
                <i className=''></i>

            </a>
        </li>

        <br />
        <br />
        <br />

        <li className='nav-item' onClick={props.loginclick}>
            <Link to = "/Login"
            className='nav-link collapsed'
            data-bs-target=''
            data-bs-toggle='collapse'>
                <i className='bi bi-gear'></i>
                <span>Log Out</span>
                <i className=''></i>

            </Link>
        </li>
        {/* {navList.map(nav => (
            
            <NavItem key={nav._id} nav={nav} />

        ))} */}
    
     </ul>
    </aside>
  );
}

export default SideBar;